import { SHOW_USER_AGREEMENT, DISPLAY_INFO_DATA, TRANSACTION_START, TRANSACTION_END, SHOW_COOKIES_INFO, MONETA_TRANSACTION_STATUS} from "../actions/types";

const userAgreementDialog =  (state = false, action) => {
  switch (action.type) {
    case SHOW_USER_AGREEMENT:
      return action.isActive;
    default:
      return state;
  }
};

const cookiesInfoDialog =  (state = false, action) => {
  switch (action.type) {
    case SHOW_COOKIES_INFO:
      return action.isActive;
    default:
      return state;
  }
};

const monetaTransactionInProccess = (state = null, action) => {
  switch (action.type) {
    case MONETA_TRANSACTION_STATUS:
      return action.status
    default:
      return state;
  }
}

const transactionInProccess = (state = false, action) => {
  switch (action.type) {
    case TRANSACTION_START:
      return true
    case TRANSACTION_END:
      return false
    default:
      return state;
  }
}

const webpageInfoData = (state = null, action) =>{
  switch (action.type) {
    case DISPLAY_INFO_DATA:
      return action.payload;
    case TRANSACTION_END:
      return action.message;
    default:
      return state;
  }
}

export default {
  userAgreementDialog,
  webpageInfoData,
  transactionInProccess,
  cookiesInfoDialog,
  monetaTransactionInProccess
}



// WEBPACK FOOTER //
// ./src/reducers/webpageReducer.js